/**
 * Legacy `$eventBus.$emit('alert-on', …)` → Vuex `commonAlert/addAlert` (GlobalAlert).
 * Payload shapes: { message, status } | { type, text } | { type, message }.
 */
export function installAlertOnBridge(eventBus, store) {
  if (!eventBus || !store) {
    return;
  }

  eventBus.$off('alert-on', onAlertOn);
  eventBus.$on('alert-on', onAlertOn);

  function onAlertOn(payload = {}) {
    const message = payload.message || payload.text || '';
    if (!message) {
      return;
    }
    const type = payload.type || payload.status || 'info';
    store.dispatch('commonAlert/addAlert', {
      type,
      message,
      timeout: payload.timeout ?? (type === 'error' ? 0 : 6000)
    });
  }
}
